import { Component, Inject } from '@angular/core';
// angular module
import { CommonModule, NgIf } from '@angular/common';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as QRCode from 'qrcode';
// import * as iconv from 'iconv-lite';
import { STRING_TYPE } from '@angular/compiler';

@Component({
  selector: 'app-modal-event-qr',
  templateUrl: './modal-event-qr.component.html',
  styleUrls: ['./modal-event-qr.component.scss'],
})
export class ModalEventQrComponent {
  showModal: boolean = false;

  qrdata: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalEventQrComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('モーダルデータ:', JSON.stringify(this.data));
    const o = this;

    if (Object.keys(o.data).length > 0) {
      o.showModal = true;
    }
    if (o.data.qrdata) {
      o.qrdata = o.data.qrdata;
      o.createQr();
    }
  }

  createQr() {
    const o = this;
    setTimeout(() => {
      let el = document.getElementById('canvasQr');
      QRCode.toCanvas(el, this.qrdata, {
        width: 250, // 幅を固定（正方形なので高さも自動的に同じになる）
      });
    }, 10);
  }
  // createQr() {
  //   const o = this;
  //   setTimeout(() => {
  //     const el = document.getElementById('canvasQr');
  //     if (!el) {
  //       console.error('QRコード要素が見つかりません');
  //       return;
  //     }

  //     // UTF-8文字列をShift-JISに変換
  //     const shiftJisBuffer = iconv.encode(this.qrdata, 'Shift_JIS');

  //     // Buffer を binary 文字列に変換
  //     const shiftJisString = shiftJisBuffer.toString('binary');

  //     // QRコード生成
  //     QRCode.toCanvas(el, shiftJisString, {
  //       width: 250,
  //       errorCorrectionLevel: 'H', // エラー修正レベルの設定
  //     })
  //       .then(() => console.log('QRコード生成完了（Shift-JISエンコード）'))
  //       .catch((error) => console.error('QRコード生成エラー:', error));
  //   }, 10);
  // }

  // createQr() {
  //   const o = this;
  //   setTimeout(() => {
  //     let el = document.getElementById('canvasQr');
  //     // エンコード処理（必要に応じて）
  //     const encodedData = encodeURIComponent(this.qrdata); // 必要に応じてエンコード
  //     QRCode.toCanvas(el, encodedData, {
  //       width: 250, // 幅を固定
  //       errorCorrectionLevel: 'H', // エラー修正レベルの設定
  //     }).catch((error) => console.error('QRコード生成エラー:', error));
  //   }, 10);
  // }

  onClick(type: string = ''): void {
    this.dialogRef.close(type);
    this.showModal = false;
  }
}

// @Component({
//   selector: 'app-modal-event-qr',
//   templateUrl: './modal-event-qr.component.html',
//   styleUrls: ['./modal-event-qr.component.scss'],
// })
// export class ModalEventQrComponent {
//   showModal: boolean = false;

//   qrdata: string = '';

//   constructor(
//     public dialogRef: MatDialogRef<ModalEventQrComponent>,
//     @Inject(MAT_DIALOG_DATA) public data: any
//   ) {
//     console.log('qrdata:', JSON.stringify(this.data));
//     const o = this;

//     if (Object.keys(o.data).length > 0) {
//       o.showModal = true;
//     }
//     if (o.data.qrdata) {
//       o.qrdata = o.data.qrdata;
//       o.createQr();
//     }
//   }

//   createQr() {
//     const o = this;
//     setTimeout(() => {
//       let el = document.getElementById('canvasQr');

//       // 文字列の場合、明示的にダブルクォーテーションを付加
//       const qrDataForCanvas =
//         typeof this.qrdata === 'string'
//           ? `"${this.qrdata}"`
//           : String(this.qrdata);

//       QRCode.toCanvas(el, qrDataForCanvas, {
//         width: 250, // 幅を固定（正方形なので高さも自動的に同じになる）
//       }).catch((err) => {
//         console.error('QRコード生成エラー:', err);
//       });
//     }, 10);
//   }

//   onClick(type: string = ''): void {
//     this.dialogRef.close(type);
//     this.showModal = false;
//   }
// }
